module.exports = __webpack_public_path__ + "static/web3_crypto_website_cover-ecdaf295f8c6b6b137b6e178d60ef1c7.png";